import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSavings = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5.9 3.766 2.971.657c2.49-.907 5.457-1.014 7.844.256 4.228 2.052 5.55 7.53 2.708 11.187-.841.97.093 2.74-.95 3.678-.793.712-1.708.902-2.663.632-.677-.249-1.227-1.057-1.999-1.048-.921.008-1.648-.065-2.57 0-.56.04-1.204.756-1.784.991-1.035.35-2.309.15-2.885-.811-.32-.699-.125-2.01-.498-2.86-.64-1.059-1.983-.673-2.594-1.732-.43-1.354-.652-3.635-.32-4.997.467-.624 1.297-1.019 1.795-1.41.471-.929 1.375-1.855 1.375-1.855z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.428 7.367c1.447-.8 3.087-.8 4.44 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSavings);
export default ForwardRef;
